import { Error } from './Error';

export default class ValidationResult {
	groupId: string | null;

	referenceSettingsIsMissing: boolean;

	productErrors: Error[];

	countryErrors: Error[];

	constructor(
		groupId: string | null,
		referenceSettingsIsMissing: boolean,
		productErrors: Error[],
		countryErrors: Error[]
	) {
		this.groupId = groupId;
		this.referenceSettingsIsMissing = referenceSettingsIsMissing;
		this.productErrors = productErrors;
		this.countryErrors = countryErrors;
	}
}
